import { Chip } from "@mui/material";
import React ,{memo}from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const OutdoorPM10KPI = memo(({ avgHum, maxHum, minHum }) => {
  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        nrOfLevels={3}
        colors={["gold", "lawngreen", "DeepSkyBlue"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={avgHum / 100}
        hideText="true"
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgHum}  μ g/m ³</span>
      <p className="card-value">PM10</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxHum}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle} />
          <p className="m-1 p-0">{minHum}</p>
        </div>
      </div>
    </>
  );
});

export default OutdoorPM10KPI;
